import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { ApiService } from 'src/app/services/api/api.service';
import { gsap, Expo } from 'gsap';

@Component({
  selector: 'app-day-button',
  templateUrl: './day-button.component.html',
  styleUrls: ['./day-button.component.scss']
})
export class DayButtonComponent {
    @ViewChild('btn', { static: false }) btn : ElementRef

    @Input('color1') color1: string
    @Input('color2') color2: string
    @Input('color3') color3: string
    @Input('color4') color4: string

    @Input('isFirst') isFirst: number
    @Input('isLast') isLast: number

    private _date: moment.Moment | undefined; 
    @Input('date')
    public get date(): moment.Moment | undefined {
        return this._date;
    }
    public set date(value: moment.Moment | undefined) {
        this._date = value;

        this.month = moment(this._date).tz('America/Los_Angeles').format('MMM')
        this.dateNumber = moment(this._date).tz('America/Los_Angeles').format('DD')
        this.day = moment(this._date).tz('America/Los_Angeles').format('ddd')
        
    }

    private _isSelected: boolean = false;
    @Input('isSelected')
    public get isSelected(): boolean {
        return this._isSelected;
    }
    public set isSelected(value: boolean) {
        this._isSelected = value;
        if(value) {
            this.onOver(null)
        }
        else {
            this.onOut(null)
        }
    }

    public month: string = ''
    public dateNumber: string = ''
    public day: string = ''

    constructor(
        public apiService : ApiService
    ) {

    }

    ngAfterViewInit() {
        setTimeout(() => {
            if(this.isSelected) {
                gsap.set(this.btn.nativeElement, {backgroundColor: this.color2, color: this.color4});
            }
            else {
                gsap.set(this.btn.nativeElement, {backgroundColor: this.color3, color: this.color1});
            }

        }, 10);
    }

    onOver(e: Event) {
        // console.log('over' + e.target)
        gsap.to(this.btn?.nativeElement, 0.3, {backgroundColor: this.color2, color: this.color4});

    }

    onOut(e: Event) {
        // console.log('out')
        if(!this.isSelected) {
            gsap.to(this.btn?.nativeElement, 0.3, {backgroundColor: this.color3, color: this.color1});
        }
    }
}
